/**
 * Hero banner carousel: slide navigation, dots, arrows, autoplay.
 * Runs once per [data-hero-banner] container. Reads autoplay config from data-hero-autoplay and data-hero-autoplay-delay.
 */
function initHeroBanner(section) {
  const track = section.querySelector('[data-hero-track]');
  if (!track) return;

  const slides = section.querySelectorAll('[data-hero-slide]');
  const panes = section.querySelectorAll('[data-hero-pane]');
  const dots = section.querySelectorAll('[data-hero-dot]');
  const prevBtn = section.querySelector('[data-hero-prev]');
  const nextBtn = section.querySelector('[data-hero-next]');
  const total = slides.length;
  let current = 0;
  let autoplayTimer = null;

  const autoplay = section.getAttribute('data-hero-autoplay') === 'true';
  const autoplayDelay = Math.max(3, parseInt(section.getAttribute('data-hero-autoplay-delay') || '5', 10));

  function goTo(index) {
    current = (index + total) % total;
    slides.forEach((slide, i) => {
      slide.classList.toggle('hero-banner__slide--active', i === current);
      slide.setAttribute('aria-hidden', i !== current);
    });
    panes.forEach((pane, i) => {
      pane.classList.toggle('hero-banner__pane--active', i === current);
    });
    dots.forEach((dot, i) => {
      dot.classList.toggle('hero-banner__dot--active', i === current);
      dot.setAttribute('aria-selected', i === current);
    });
    resetAutoplay();
  }

  function next() {
    goTo(current + 1);
  }

  function prev() {
    goTo(current - 1);
  }

  function resetAutoplay() {
    if (autoplayTimer) clearInterval(autoplayTimer);
    if (autoplay && total > 1 && autoplayDelay > 0) {
      autoplayTimer = setInterval(next, autoplayDelay * 1000);
    }
  }

  if (prevBtn) prevBtn.addEventListener('click', prev);
  if (nextBtn) nextBtn.addEventListener('click', next);

  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => goTo(i));
    dot.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        goTo(i);
      }
    });
  });

  resetAutoplay();
}

function initHeroBanners() {
  document.querySelectorAll('[data-hero-banner]').forEach((section) => {
    if (section.querySelector('[data-hero-track]')) {
      initHeroBanner(section);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeroBanners);
} else {
  initHeroBanners();
}
